/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S6_BodyInputs */

const tr_kvkkbasvuru_s6_body = /** @type {(inputs: Kvkkbasvuru_S6_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başvurular, KVKK Madde 28 kapsamında istisnai haller barındırıyorsa veya bir başka gerçek kişinin hak ve özgürlüklerini ihlal edecek nitelikteyse reddedilebilir. Red gerekçeleri başvuru sahibine yazılı olarak bildirilir.`)
};

const en_kvkkbasvuru_s6_body = /** @type {(inputs: Kvkkbasvuru_S6_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applications may be rejected if they involve the exceptional circumstances under KVKK Article 28 or if they are of a nature that would violate the rights and freedoms of another natural person. The grounds for rejection are notified to the applicant in writing.`)
};

const de_kvkkbasvuru_s6_body = /** @type {(inputs: Kvkkbasvuru_S6_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anträge können abgelehnt werden, wenn sie Ausnahmetatbestände nach KVKK Artikel 28 betreffen oder geeignet sind, die Rechte und Freiheiten einer anderen natürlichen Person zu verletzen. Die Ablehnungsgründe werden dem Antragsteller schriftlich mitgeteilt.`)
};

const ru_kvkkbasvuru_s6_body = /** @type {(inputs: Kvkkbasvuru_S6_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обращения могут быть отклонены, если они подпадают под исключительные случаи, предусмотренные статьёй 28 KVKK, или по своему характеру нарушают права и свободы другого физического лица. Основания отказа сообщаются заявителю в письменной форме.`)
};

/**
* | output |
* | --- |
* | "Applications may be rejected if they involve the exceptional circumstances under KVKK Article 28 or if they are of a nature that would violate the rights and..." |
*
* @param {Kvkkbasvuru_S6_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s6_body = /** @type {((inputs?: Kvkkbasvuru_S6_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S6_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s6_body(inputs)
	if (locale === "de") return de_kvkkbasvuru_s6_body(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s6_body(inputs)
	return tr_kvkkbasvuru_s6_body(inputs)
});